import _unionWith from "lodash/unionWith";
import _merge from "lodash/merge";

export default (store) => {
  var auth = getItem("nirex.auth") || {};
  store.commit("LOGIN", auth);

  store.subscribe((mutation) => {
    if (mutation.type === "LOGIN") {
      auth = mutation.payload;
      setItem("nirex.auth", auth);
    }
    if (mutation.type === "STORE_CUSTOMER") {
      auth.customer = mutation.payload;
      setItem("nirex.auth", auth);
    }
    if (mutation.type === "UPDATE_CUSTOMER") {
      auth.customer = _merge(auth.customer, mutation.payload);
      setItem("nirex.auth", auth);
    }
    if (mutation.type === "STORE_CARD") {
      let card = mutation.payload;
      auth.customer.cards = _unionWith(
        [card],
        auth.customer.cards,
        (a, b) => a.id === b.id
      );
      setItem("nirex.auth", auth);
    }
    if (mutation.type === "REMOVE_CARD") {
      let cardId = mutation.payload;
      auth.customer.cards = auth.customer.cards.filter((c) => c.id !== cardId);
      setItem("nirex.auth", auth);
    }
    if (mutation.type === "LOGOUT") {
      removeItem("nirex.auth");
    }
  });
};

function getItem(key) {
  return JSON.parse(localStorage.getItem(key));
}

function setItem(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function removeItem(key) {
  localStorage.removeItem(key);
}
